interface SuccessStageProps {
  onClose: () => void;
}

export const SuccessStage = ({ onClose }: SuccessStageProps) => {
  return (
    <div className="text-center space-y-4">
      <div className="text-green-600 text-5xl mb-4">✓</div>
      <h2 className="text-2xl font-bold">Profile Updated Successfully</h2>
      <p className="text-gray-600">
        We have updated your information and we will reach out to you.
      </p>
      <button
        onClick={onClose}
        className="w-full bg-black text-white py-3 rounded-full text-base font-medium hover:bg-gray-800 transition-colors"
      >
        Finish
      </button>
    </div>
  );
};
